import React from 'react';
import { Button } from '@saucelabs/ds-button';

export type FilterFooterProps = {
  activeFilters: number;
  clearFilters: () => void;
  closeFilters: () => void;
};

const FilterFooter: React.FC<FilterFooterProps> = ({
  activeFilters,
  clearFilters,
  closeFilters,
}) => (
  <div
    className="flex flex-row justify-between items-center px-2.5 py-1.5"
    data-qa="manual-search-filter-footer"
  >
    <span className="mr-auto">
      {`${activeFilters} active filter${activeFilters === 1 ? '' : 's'}`}
    </span>
    <Button
      aria-label="clear-filter"
      data-qa="manual-search-filter-footer-button-clear"
      onPress={clearFilters}
      variant="text"
    >
      Clear
    </Button>
    <Button
      aria-label="close-filter"
      data-qa="manual-search-filter-footer-button-done"
      onPress={closeFilters}
      variant="text"
    >
      Done
    </Button>
  </div>
);

export default FilterFooter;
